import { useAuth } from '@opendoor/auth-fe/context';
import { useQuery } from '@tanstack/react-query';
import { requestZeusFromBrowserAllowPartialData } from 'components/api/zeusBrowserClient';
import { captureError } from 'helpers/captureError';

import type { HubSellerTransactionsQuery } from './__generated__/hub-seller-transactions.zeus';
import { HubSellerTransactionsDocument } from './__generated__/hub-seller-transactions.zeus';

export type HubSellingTransaction =
  HubSellerTransactionsQuery['customerAccount']['seller']['transactions'][number];

export function useHubSellerTransactions() {
  const { authentication } = useAuth();
  const customerUuid =
    authentication.state === 'authenticated' ? authentication.user.customerUuid : null;
  return useQuery({
    queryKey: ['hub', 'seller-transactions', customerUuid],
    enabled: customerUuid !== null,
    meta: { captureErrorContext: 'HubSellerTransactions' },
    queryFn: async ({ signal }) => {
      const result = await requestZeusFromBrowserAllowPartialData({
        document: HubSellerTransactionsDocument,
        variables: {},
        signal,
      });
      for (const error of result.errors) {
        captureError(error, 'HubSellerTransactions');
      }
      return result.data?.customerAccount.seller.transactions ?? null;
    },
  });
}
